import { TextFieldForm } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import ToggleDisplayEditFormItem from '../../../../components/ToggleDisplayEditFormItem';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { useStyles } from './style';
import {
  Type,
  useGetWorkPassTypes, WorkPassType,
} from '../../../../api-refactored/candidate/useGetWorkPassTypes';

const userIdTypePassport = 'Passport';

interface AEISDetailsProps {
  isEditState: boolean;
  finPassport?: string;
  form?: UseFormReturn<any>;
  workPassType?: string;
  userIdType?: string;
}

const AEISDetails = ({
  isEditState,
  finPassport,
  form,
  workPassType,
  userIdType,
}: AEISDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const finPassportNoLabel =
    userIdType === userIdTypePassport
      ? t('exam->>ReviewExam.FIN')
      : t('exam->>ReviewExam.PassportNo');

  const finPassportNoSubLabel =
    userIdType === userIdTypePassport && t('exam->>ReviewExam.FINStatement');

  const {
    data: workPassTypes,
    isLoading: isLoadingWorkPassTypes,
    error: errorWorkPassTypes,
    refetch: refetchWorkPassTypes,
  } = useGetWorkPassTypes({ enabled: isEditState, type: Type.candidate });

  return (
    <>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('exam->>ReviewExam.WorkPassType')}
        valueText={workPassType}
        containerClassName={`${classes.formElementContainer}`}
        EditComponent={
          form && (
            <ControlledAutocomplete<WorkPassType, false, false, undefined>
              control={form.control}
              name="workPassType"
              label={t('exam->>ReviewExam.WorkPassType')}
              placeholder="Select work pass type"
              id="input-select-work-pass-type"
              error={!!form?.formState.errors.workPassType}
              helperText={form?.formState.errors?.workPassType?.message?.toString()}
              loading={isLoadingWorkPassTypes}
              loadingError={!!errorWorkPassTypes}
              loadingErrorOnReFetch={refetchWorkPassTypes}
              options={workPassTypes || []}
              getOptionLabel={({ description }) => description}
              isOptionEqualToValue={(option, value) => `${option.code}` === `${value.code}`}
              fullWidth
              isRequired
            />
          )
        }
      />

      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={finPassportNoLabel}
        valueText={finPassport}
        containerClassName={classes.formElementContainer}
        EditComponent={
            form && <TextFieldForm
              form={form}
            label={finPassportNoLabel}
            subLabel={finPassportNoSubLabel}
            defaultValue={finPassport}
            isSubLabelBelowLabel
            onChange={(e) => form?.setValue('finPassportNo', e.target.value.toUpperCase())}
            error={!!form?.formState.errors.finPassportNo}
            helperText={form?.formState.errors?.finPassportNo?.message?.toString()}
            name="finPassportNo"
            type="text"
            fullWidth
            isRequired={userIdType !== userIdTypePassport}
          />
        }
      />
    </>
  );
};
export default AEISDetails;
